import React, { useState, useEffect, useRef } from 'react';
import { getUnshownNotifications, markNotificationsShown } from '../services/api';
import './NotificationPopup.css';

function NotificationPopup() {
  const [notifications, setNotifications] = useState([]);
  const [visible, setVisible] = useState(false);
  const audioRef = useRef(null);
  const hasPlayedSound = useRef(false);
  const shownIds = useRef(new Set());

  useEffect(() => {
    checkNotifications();
    const interval = setInterval(checkNotifications, 10000);
    return () => clearInterval(interval);
  }, []);

  // סגירה אוטומטית אחרי 5 שניות
  useEffect(() => {
    if (visible && notifications.length > 0) {
      const timer = setTimeout(() => {
        dismissAll();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [visible, notifications]);

  const checkNotifications = async () => {
    try {
      const response = await getUnshownNotifications();
      const newNotifications = response.data.notifications || [];
      
      // סינון רק התראות שלא הוצגו עדיין בסשן הזה
      const reallyNew = newNotifications.filter(n => !shownIds.current.has(n._id));
      
      if (reallyNew.length > 0) {
        // הוספת ה-IDs לרשימת מה שכבר הוצג
        reallyNew.forEach(n => shownIds.current.add(n._id));
        
        setNotifications(reallyNew);
        setVisible(true);
        
        // צליל רק פעם אחת
        if (!hasPlayedSound.current) {
          playSound();
          hasPlayedSound.current = true;
          // אפשר צליל חדש אחרי 30 שניות
          setTimeout(() => { hasPlayedSound.current = false; }, 30000);
        }
      }
    } catch (error) {
      console.error('שגיאה בטעינת התראות:', error);
    }
  };

  const playSound = () => {
    try {
      const audio = new Audio('https://cdn.pixabay.com/audio/2022/03/24/audio_805cb26611.mp3');
      audio.volume = 0.5;
      audio.play().catch(e => console.log('Cannot play sound:', e));
    } catch (e) {
      console.log('Sound error:', e);
    }
  };

  const dismissAll = async () => {
    try {
      const ids = notifications.map(n => n._id);
      if (ids.length > 0) {
        await markNotificationsShown(ids);
      }
      setNotifications([]);
      setVisible(false);
    } catch (error) {
      console.error('שגיאה בסימון התראות:', error);
    }
  };

  const dismissNotification = async (notificationId) => {
    try {
      await markNotificationsShown([notificationId]);
      const remaining = notifications.filter(n => n._id !== notificationId);
      setNotifications(remaining);
      if (remaining.length === 0) {
        setVisible(false);
      }
    } catch (error) {
      console.error('שגיאה בסימון התראה:', error);
    }
  };

  if (!visible || notifications.length === 0) return null;

  return (
    <div className="notification-popup-container">
      
      
      <div className="notification-popup">
        <div className="notification-header">
          <h4>🔔 התראות חדשות ({notifications.length})</h4>
          <button className="btn-dismiss-all" onClick={dismissAll}>✕</button>
        </div>
        
        <div className="notification-list">
          {notifications.map(notification => (
            <div key={notification._id} className="notification-item">
              <div className="notification-content">
                <strong>{notification.title}</strong>
                <p>{notification.message}</p>
                {notification.groupId && (
                  <span className="notification-group">📁 {notification.groupId.name}</span>
                )}
              </div>
              <button className="btn-dismiss" onClick={() => dismissNotification(notification._id)}>✕</button>
            </div>
          ))}
        </div>
        
        <div className="notification-progress">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
}

export default NotificationPopup;